import { NavigationService } from './../../../../core/services/navigation.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';

@Component({
  selector: 'app-deployment-left-panel',
  templateUrl: './deployment-left-panel.component.html',
  styleUrls: ['./deployment-left-panel.component.scss'],
})
export class DeploymentLeftPanelComponent implements OnInit {
  properties = [
    {
      name: 'Summary',
      routerLink: 'summary',
      spanClass: 'bi bi-clipboard',
    },
    {
      name: 'Nodes',
      routerLink: 'nodes',
      spanClass: 'bi bi-diagram-3',
    },
    {
      name: 'Applications',
      routerLink: 'applications',
      spanClass: 'bi bi-disc',
    },
    {
      name: 'Jobs',
      routerLink: 'jobs',
      spanClass: 'bi bi-briefcase',
    },
    {
      name: 'Storage',
      routerLink: 'storage',
      spanClass: 'bi bi-hdd',
    },
    {
      name: 'Users',
      routerLink: 'users',
      spanClass: 'bi bi-people',
    },
    {
      name: 'Reports',
      routerLink: 'graphs',
      spanClass: 'bi bi-graph-up-arrow',
    },
    {
      name: 'Logs',
      routerLink: 'logs',
      spanClass: 'bi bi-body-text',
    },
    {
      name: 'Settings',
      routerLink: 'settings',
      spanClass: 'bi bi-gear',
    },

  ];

  selectedIndex: number;
  tempName: string;

  constructor(
    private navService: NavigationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.navService.sendParentData('Summary');
    this.navService.index.subscribe((x) => (this.selectedIndex = x));
  }

  sendData(index: number, property) {
    if(index == this.selectedIndex) return;
    this.navService.breadcrumbActiveProperty.subscribe((x) => {
      this.tempName = x;
    });
    if (property.name == Entities.Jobs && this.tempName == Entities.Jobs) {
      let url = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([decodeURI(url)]);
      });
    }
    this.navService.sendLeftPanelIndex(index);
    this.navService.sendParentData(property.name);
    this.router.navigate([property.routerLink], { relativeTo: this.route })
    this.navService.selectedLogType = "Deployment";
  }
}
